<div class="modal-dialog">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn  fis-btn" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
        </div>
        <div class="modal-body">
            <img src="assets/offline/saved.png" />
            <h2>{{ 'LABELS.CONGRATULATIONS' | translate}} <b></b></h2>
            <p>{{ 'LABELS.CLAIM_NUMBER' | translate}} <b>CLR65456 </b> {{ 'LABELS.SUCCESSFULLY_RAISED' | translate}}</p>
            <p>{{ 'LABELS.TRACK_IN_VIEW_TRANSACTION' | translate}} </p>
        
            <button class="btn fis-btn" expand="block" (click)="close()">{{ 'LABELS.OK' | translate}}</button>
        </div>
    </div>
</div>